<!--
    TM-1000002000
    Rahmen der Consultant-Seite „Meine Anträge" — die gesamte Fläche liegt in <cw-my-requests>
    (EINE Tabelle „Laufende Anträge", nur Vorgänge). Vorbild: tickets.page.html der Ticketseite.
-->
@if (initialized) {
    <cw-my-requests></cw-my-requests>
}
